"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicChannelService = void 0;
const tslib_1 = require("tslib");
const queries_1 = require("./queries");
const mappers_1 = require("./mappers");
const base_public_service_1 = require("../base-public-service");
const common_1 = require("@wix/wix-vod-shared/common");
const mapVideosResp = (resp) => {
    return {
        total: resp.total,
        cursor: resp.cursor,
        items: resp.entities.map((video) => (0, mappers_1.mapGqlPublicVideoToOld)(video)),
    };
};
class PublicChannelService extends base_public_service_1.BasePublicService {
    getChannelVideos(opts) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const maxLimit = 20;
            const { sort, query, tag, category, videosCount } = opts;
            const channelId = (0, common_1.dashify)(opts.channelId);
            let itemsToLoad = videosCount;
            let items = [];
            let total;
            let cursor = opts.cursor;
            while (itemsToLoad > 0) {
                const limit = itemsToLoad < maxLimit ? itemsToLoad : maxLimit;
                const { channel: { videos }, } = yield this.client.request(queries_1.GET_VIDEOS_QUERY, {
                    channelId,
                    cursor,
                    limit,
                    sort,
                    query,
                    tag,
                    category,
                });
                cursor = videos.cursor;
                total = videos.total;
                items = [
                    ...items,
                    ...videos.entities.map((video) => (0, mappers_1.mapGqlPublicVideoToOld)(video)),
                ];
                itemsToLoad = cursor ? itemsToLoad - limit : 0;
            }
            return {
                total,
                cursor,
                items,
            };
        });
    }
    getWidgetData(_opts) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { singleVideoId } = _opts, opts = tslib_1.__rest(_opts, ["singleVideoId"]);
            if (singleVideoId) {
                return {
                    isSingleVideo: true,
                    singleVideo: yield this.getVideo(singleVideoId),
                };
            }
            const { channel } = yield this.client.request(queries_1.GET_WIDGET_DATA_QUERY, opts);
            return {
                isSingleVideo: false,
                channel: channel ? (0, mappers_1.mapGqlPublicChannelToOld)(channel) : null,
                videos: mapVideosResp(channel.videos),
            };
        });
    }
    getChannel(channelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.request(queries_1.GET_CHANNEL_QUERY, {
                channelId: (0, common_1.dashify)(channelId),
            });
            const channel = (0, mappers_1.mapGqlPublicChannelToOld)(resp.channel);
            return { data: channel };
        });
    }
    getChannelVideo(channelId, videoId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.request(queries_1.GET_CHANNEL_VIDEO_QUERY, {
                channelId,
                videoId,
            });
            return (0, mappers_1.mapGqlPublicVideoToOld)(resp.channel.video);
        });
    }
    getVideo(videoId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.request(queries_1.GET_VIDEO_QUERY, { videoId });
            return (0, mappers_1.mapGqlPublicVideoToOld)(resp.video);
        });
    }
    getChannelVideoPlayUrls(videoId, channelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.request(queries_1.GET_CHANNEL_VIDEO_PLAY_URLS_QUERY, {
                videoId,
                channelId,
            });
            return {
                'hls.m3u8': resp.channel.video.play.entity.hls,
            };
        });
    }
    getChannelTrailerUrl(channelId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.client.request(queries_1.GET_CHANNEL_PLAY_URL_QUERY, {
                channelId,
            });
            return {
                'hls.m3u8': resp.channel.play.entity.hls,
            };
        });
    }
}
exports.PublicChannelService = PublicChannelService;
//# sourceMappingURL=channel.js.map